import { useNavigate, useParams } from 'react-router';
import styles from './DisbursementExpired.module.scss';
import { useEffect, useState } from 'react';
import { RestS } from '../../../rest/rest-service';
import { DisbursementColdState, LendingStatus, disbursementRoutes } from '../../../interfaces/interfaces';
import CircularLoader from '../../../components/common/CircularLoader/CircularLoader';
import DisbursementHeader from '../DisbursementHeader/DisbursementHeader';
import { MdOutlineWatchLater as WatchIcon } from 'react-icons/md'



const DisbursementExpired = () => {
    const { formId } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);

    const checkAndSetJourneyStatus = async () => {
        try {


            const { state, success, disbursementData, formSteps } = await RestS.getDisbursementFormData(Number(formId));

            if (state == DisbursementColdState.accessDenied) {
                navigate('/404', {
                    replace: true
                })
            } else if (state == DisbursementColdState.linkExpired) {
                // navigate to link expired page
            } else {
                console.log('disbursementFormData', disbursementData);
                const successStatuses = new Set([LendingStatus.APPROVED, LendingStatus.PENDING_APPROVAL, LendingStatus.REJECTED])
                if (successStatuses?.has(disbursementData['applicationStatus'])) {
                    // setDisbursementData(disbursementData?.data);
                    navigate(`${disbursementRoutes?.disbursementSections}/${disbursementRoutes?.disbursementSuccess}/${formId}`, { replace: true })
                } else {
                    // setDisbursementData(disbursementData?.data);
                    navigate(`${disbursementRoutes?.disbursementSections}/${formId}`, { replace: true })
                }
            }
        } catch (error) {
            console.log('error', error);
            throw error;
        }
    }

    useEffect(() => {
        // setLoading(false)
        (async () => {
            try {
                await checkAndSetJourneyStatus();
            } catch (error) {
                console.log('error', error)
            } finally {
                setLoading(false);
            }
        })()
    }, [])

    return (
        <div className={styles.rootContainer}>
            {loading ?
                <div className={styles.loadingContainer}>
                    <CircularLoader />
                </div>
                :
                <div className={styles.rootContainer}>
                    <DisbursementHeader />
                    <div className={styles.bodyContainer}>
                        <div className={styles.expiredContainer}>
                            <div className={styles.expiredIconContainer}>
                                <WatchIcon />
                            </div>
                            <div className={styles.successTitle}>
                                Link Expired!
                            </div>
                            <div className={styles.successSubText}>
                                Reapply for disbursement through WhatsApp.
                            </div>
                        </div>
                    </div>
                </div>}
        </div>
    );
}

export default DisbursementExpired;